<template>
  <div class="form-employee-work" role="group">
    <div class="form-employee-work__days">
      <input
        aria-label="Выбор количества рабочих дней"
        class="number-days form-employee-work__input"
        v-bind:min="$options.minNumberDays"
        v-bind:max="$options.maxNumberDays"
        v-mask="`##`"
        type="number"
        inputmode="numeric"
        v-bind:value="daysThoughtDays.numberWorkingDays"
        v-on:input="onInputNumberWorkingDays"
      />
      <span class="form-employee-work__days__text">дня через</span>
      <input
        aria-label="Выбор количества выходных дней"
        class="number-days form-employee-work__input"
        v-bind:min="$options.minNumberDays"
        type="number"
        inputmode="numeric"
        v-model="daysThoughtDays.numberOffDays" />
      <div class="form-employee-work__days__date-wrapper">
        <span class="form-employee-work__days__text">с&nbsp;</span>
        <date-range-picker-dialog
          v-bind:value="daysThoughtDays.startsDate"
          v-on:input="onInputStartsDate"
        >
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="form-employee-work__days__data"
              type="button"
              v-on="listenerObject"
            >{{ startsDateTitle }}</button>
          </template>
        </date-range-picker-dialog>
      </div>
    </div>
    <div class="form-employee-work__work-days">
      <div v-for="(workTimes, dayIndex) in daysThoughtDays.workDays" v-bind:key="dayIndex" class="form-employee-work__days__group">
        <span class="form-employee-work__days__text">
          {{ dayIndex + 1 }}-й день
        </span>
        <div
          class="form-employee-work__row"
          v-for="(times, index) in workTimes"
          v-bind:key="times.key"
        >
          <time-interval-picker
            class="form-employee-work__row"
            v-bind:initial-from="times.from"
            v-bind:initial-to="times.to"
            v-bind:time-set="suggestedHours"
            v-on:input-from="onInputWorkTime(dayIndex, index, $event, times.to)"
            v-on:input-to="onInputWorkTime(dayIndex, index, times.from, $event)"
          />
          <button
            v-if="index === 0"
            title="Добавить"
            class="form-employee-work__button-add"
            type="button"
            v-bind:disabled="workTimes.length >= maxWorkIntervalsInDay"
            v-on:click="onAddWorkTimes(dayIndex)" />
          <button
            v-else
            class="form-employee-work__button-remove"
            title="Удалить"
            type="button"
            v-on:click="onRemoveWorkTimes(dayIndex, index)" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateRangePickerDialog from '@/components/DateRangePickerDialog.vue';
import TimeIntervalPicker from '@/components/TimeIntervalPicker.vue';

/**
 * @description Минимальное количество дней.
 * @type {number}
 */
const minNumberDays = 1;

/**
 * @description Максимальное количество дней.
 * @type {number}
 */
const maxNumberDays = 99;

function WorkTimes(from, to, key) {
  this.from = from;
  this.to = to;
  this.key = key;
}

/**
 * @description Дни через дни.
 * @param {string} from              Часа начала работы.
 * @param {string} to                Часы окончания работы.
 * @param {number} numberOffDays     Количество выходных дней.
 * @param {number} numberWorkingDays Количество рабочих дней.
 * @param {Date}   startsDate        Дата начала отсчета.
 * @param {any[]}  workDays          Рабочие дни.
 * @constructor
 */
export function DaysThroughDays(
  from,
  to,
  numberOffDays = minNumberDays,
  numberWorkingDays = minNumberDays,
  startsDate = new Date(),
  workDays = [[new WorkTimes(from, to, Date.now())]],
) {
  this.numberOffDays = numberOffDays;
  this.numberWorkingDays = numberWorkingDays;
  this.startsDate = startsDate;
  this.workDays = workDays;
}

/**
 * @description Компонент выбора режима дни-через-дни.
 */
export default {
  components: {
    DateRangePickerDialog,
    TimeIntervalPicker,
  },
  computed: {
    startsDateTitle: (vm) => {
      const options = {
        day: 'numeric',
        month: 'long',
      };
      return vm.daysThoughtDays.startsDate.toLocaleDateString('ru-RU', options);
    },
  },
  data() {
    return { daysThoughtDays: this.value };
  },
  inject: ['maxWorkIntervalsInDay'],
  methods: {
    findDay(dayIndex) {
      return this.daysThoughtDays.workDays[dayIndex];
    },
    onAddWorkTimes(dayIndex) {
      this.findDay(dayIndex).push(new WorkTimes(this.initialFrom, this.initialTo, Date.now()));
      this.onInput(this.daysThoughtDays);
    },
    onRemoveWorkTimes(dayIndex, timesIndex) {
      this.findDay(dayIndex).splice(timesIndex, 1);
      this.onInput(this.daysThoughtDays);
    },
    onInputWorkTime(dayIndex, timesIndex, from, to) {
      const times = this.findDay(dayIndex)[timesIndex];
      times.from = from;
      times.to = to;
      this.onInput(this.daysThoughtDays);
    },
    onInputNumberWorkingDays(event) {
      const { value } = event.target;
      const oldValue = this.daysThoughtDays.workDays.length;
      if (value > oldValue) {
        const newDays = new Array(value - oldValue)
          .fill([new WorkTimes(this.initialFrom, this.initialTo, Date.now())]);
        this.daysThoughtDays.workDays.push(...newDays);
      } else if (oldValue > value) {
        this.daysThoughtDays.workDays = this.daysThoughtDays.workDays.slice(0, value);
      }
      this.daysThoughtDays.numberWorkingDays = value;
      this.onInput(this.daysThoughtDays);
    },
    onInputStartsDate(value) {
      this.daysThoughtDays.startsDate = value;
      this.$emit('input', this.daysThoughtDays);
    },
    onInput(value) {
      this.$emit('input', value);
    },
  },
  maxNumberDays,
  minNumberDays,
  name: 'DaysThroughDaysPicker',
  props: {
    value: {
      default: () => new DaysThroughDays(),
      type: DaysThroughDays,
    },
    /**
     * @description Предложенные часы работы.
     */
    suggestedHours: { default: () => [], type: Array },
    /**
     * @description Часы работы от.
     */
    initialFrom: { default: () => '00:00', type: String },
    /**
     * @description Часы работы до.
     */
    initialTo: { default: () => '00:00', type: String },
  },
  watch: {
    value(newValue) {
      this.daysThoughtDays = newValue;
    },
  },
};
</script>
<style scoped lang="scss">
@use "@/scss/buttons";

.form-employee-work {
  border: none;
  padding: 0 0 0 27px;
  margin: 5px 0 20px 0;
  &__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
  &__days {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    &__group {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin: 20px 0 0 0;
    }
    &__date-wrapper {
      display: flex;
      column-gap: 10px;
    }
    &__text {
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
    }
    &__data {
      color: var(--action-color);
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
    }
  }
  &__work-days {
    width: 90%;
  }
  &__button {
    &-add {
      text-align: left;
      color: #0489e0;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      @include buttons.btn-plus-color-add;
    }
    &-remove {
      text-align: left;
      color: var(--warning-color);
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      @include buttons.btn-cross-color-remove;
    }
  }
  &__input {
    border: 1px solid #C2CFE0;
    box-sizing: border-box;
    border-radius: 4px;
    appearance: textfield;
    height: 40px;
    width: min(100%, 65px);
    min-width: 60px;
    padding: 10px;
    color: #707683;
    font-size: 16px;
    &:focus {
      color: #192a3e;
      background-color: #fff;
      border: 1px solid #0489e0 !important;
      outline: 0;
    }
    &:disabled {
      background-color: #fff;
    }
  }
}
</style>
